import { configService } from "@/settings/api-url";
import store from "@/store/store";
const actions = {
  async action_getAllSubscriptions({ commit }, payload) {
    try {
      const res = await configService(`commerces/${payload.commerceId}/subscriptions`);
      if (res && res.data && res.data.subscriptions) {
        commit("ALL_SUBSCRIPTIONS", res.data.subscriptions);
        const allSubs = store.getters.getAllSubscriptions;
        if (allSubs && Array.isArray(allSubs) && allSubs.length) {
          const firstSubscription = store.getters.getAllSubscriptions[0];
          commit("SUBSCRIPTION", firstSubscription);
        } else {
          commit("SUBSCRIPTION", null);
        }
        return res.data.subscriptions;
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_createSubscription({ dispatch }, payload) {
    try {
      const res = await configService(`commerces/${payload.commerceId}/subscriptions`, {
        method: "POST",
        data: payload.subscription,
      });
      await dispatch("action_getAllSubscriptions", payload);
      if (res && res.data) {
        return res.data;
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_updateSubscription({ dispatch }, payload) {
    try {
      const res = await configService(
        `commerces/${payload.commerceId}/subscriptions/${payload.subscriptionId}`,
        {
          method: "PATCH",
          data: payload.subscription,
        }
      );
      await dispatch("action_getAllSubscriptions", payload);
      if (res && res.data) {
        return res.data;
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_getMenus({ commit }, payload) {
    try {
      const res = await configService(`commerces/${payload.commerceId}/menus`);
      if (res && res.data) {
        commit("MENUS", res.data);
        commit("ALL_MENU_ITEM_PRODUCTS", res.data);
        return res.data;
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_getMenuOptions({ commit }, payload) {
    try {
      const res = await configService(
        `commerces/${payload.commerceId}/menus/${payload.menuId}/menu_options`
      );
      if (res && res.data) {
        commit("MENU_OPTIONS", res.data);
        return res.data;
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_getPlates({ commit }, payload) {
    try {
      let url = `/commerces/${payload.commerceId}/menus/${payload.menuId}/menu_options/chef_suggestions_search?`;
      if (payload.avoid) url += `avoid=${payload.avoid}&`;
      if (payload.menuOptionId) url += `menu_option_ids=${payload.menuOptionId}`;
      const res = await configService(url);
      if (res && res.data) {
        commit("PLATES_OPTIONS", res.data);
        return res.data;
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_getTags({ commit }) {
    try {
      const res = await configService(`/tags`);
      if (res && res.data) {
        commit("TAGS", res.data);
        return res.data;
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_getMenuItems({ commit }, payload) {
    try {
      const res = await configService(`/commerces/${payload.commerceId}/menu_items`);
      if (res && res.data) {
        commit("MENU_ITEMS", res.data);
        return res.data;
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_applyDiscountCode({ dispatch }, payload) {
    try {
      await configService(
        `/commerces/${payload.commerceId}/subscriptions/${payload.subscriptionId}/apply_coupon`,
        {
          method: "PATCH",
          data: payload.code,
        }
      );
      await dispatch("action_getAllSubscriptions", payload);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_removeDiscountCode({ dispatch }, payload) {
    try {
      await configService(
        `commerces/${payload.commerceId}/subscriptions/${payload.subscriptionId}/remove_coupon`,
        {
          method: "PATCH",
          data: payload.code,
        }
      );
      await dispatch("action_getAllSubscriptions", payload);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_changePlate({ dispatch }, payload) {
    try {
      await configService(
        `/commerces/${payload.commerceId}/subscriptions/${payload.subscriptionId}`,
        {
          method: "PATCH",
          data: payload.payload,
        }
      );
      await dispatch("action_getAllSubscriptions", payload);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_getIngredients({ commit }, payload) {
    try {
      let url = `/commerces/${payload.commerceId}/menus/${payload.menu_id}/menu_options/search?`;
      if (payload.menu_option_id) url += `menu_option_id=${payload.menu_option_id}&`;
      if (payload.menu_item_id) url += `menu_item_id=${payload.menu_item_id}&`;
      if (payload.noInclude) url += `avoid=${payload.noInclude}`;
      const res = await configService(url);
      if (res && res.data) {
        commit("INGREDIENTS", res.data);
        return res.data;
      }
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_changeIngredient({ dispatch }, payload) {
    try {
      await configService(
        `/commerces/${payload.commerceId}/subscriptions/${payload.subscriptionId}`,
        {
          method: "PATCH",
          data: payload.payload,
        }
      );
      await dispatch("action_getAllSubscriptions", payload);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_confirmSubscriptionOrder({ dispatch }, payload) {
    try {
      await configService(
        `/commerces/${payload.commerceId}/subscriptions/${payload.subscriptionId}/create_order`,
        {
          method: "POST",
        }
      );
      await dispatch("action_getAllSubscriptions", payload);
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_getOrdersHistory({}, payload) {
    try {
      let url = `/commerces/${payload.commerceId}/subscriptions/${payload.subscriptionId}/orders?`;
      if (payload.page) url += `page=${payload.page}&`;
      if (payload.perPage) url += `per_page=${payload.perPage}`;
      const { data } = await configService(url);
      return data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async action_getMenuPrices({ commit }) {
    try {
      const { data } = await configService(`/menu_prices`);
      commit("MENU_PRICES", data);
      return data;
    } catch (error) {
      return Promise.reject(error);
    }
  },
};

export default actions;
